import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Api } from "../../services/api";
import { Globals } from "../../services/globals";
import { Utility } from "src/app/services/utility";

@Component({
    selector: "login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    standalone: false
})
export class LoginComponent {
    username: string;
    password: string;
    loginFailed: boolean = false;
    authenticating: boolean = true;

    constructor(
        private api: Api,
        private router: Router,
        private route: ActivatedRoute,
        public globals: Globals,
        public utility: Utility,
    ) {
    }

    async login() {
        this.authenticating = true;
        this.loginFailed = false;
        let result = await this.api.public().post<any>(`/login`, {
            username: this.username,
            password: this.password,
        });

        if (result.succeeded) {
            await this.api.loadCurrentUser();
            if (this.globals.currentUser) {
                await this.redirectUser();
                return;
            }
        }

        this.loginFailed = true;
        this.authenticating = false;
    }

    async ngOnInit() {
        this.globals.loadAdminKey();
        const shopDomain = this.route.snapshot.queryParamMap.get('shop');
        if (shopDomain) {
            localStorage.setItem('shopify_shop_domain', shopDomain);
        }
        let accessToken = this.route.snapshot.queryParamMap.get('accessToken');
        if (accessToken) {
            await this.loginWithAccessToken(accessToken);
            return;
        }

        await this.api.loadCurrentUser();
        if (this.globals.currentUser) {
            await this.redirectUser();
            return;
        }

        this.authenticating = false;
    }

    async loginWithAccessToken(accessToken: string) {
        let result = await this.api.public().post<any>(`/login/access-token`, {
            accessToken
        });

        if (result.succeeded) {
            await this.api.loadCurrentUser();
            if (this.globals.currentUser) {
                await this.redirectUser();
                return;
            }
        }

        this.loginFailed = true;
        this.authenticating = false;
    }

    async redirectUser() {
        let user = this.globals.currentUser;
        if (user) {
            if (user.role == "ACE") {
                this.router.navigate([this.globals.adminPanelUrl("/stores")]);
            } else {
                this.router.navigate([
                    this.globals.storeUrl("/", user.storeIds[0]),
                ]);
            }
        }
    }
}
